<template>
  <div class="index py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.company.list")}}</span>
    <div class="list-container">
      <AveineCompanyList :APIbaseURL="APIbaseURL" :adminMode="true" />
    </div>
  </div>
</template>

<script>
import { AveineCompanyList } from 'aveine-company';

export default {
  name: 'Index',
  data() {
    return {
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  components: {
    AveineCompanyList
  }
}
</script>
